import { connect } from 'react-redux'
import SubOrderGroup from './SubOrderGroup'

import onUpdateField from './Handlers/onUpdateField'

const mapStateToProps = (state) => ({
  setPercentage: state.screens.SubOrder.subOrder ? state.screens.SubOrder.subOrder.set_percentage : null,
})

const actionCreators = {
  onUpdateField,
}

export default connect(mapStateToProps, actionCreators)(SubOrderGroup)
